module.exports = __webpack_public_path__ + "img/ics_f_thumb-bad-white.848eadd0.svg";